/* @flow */
import { RecentSearch, LatLng, City, Marker, ZipCode, Key } from './constants';
import { UserStorage } from './storage';
import { setMdlVal, capitalize, memoize } from './utils';
import { stateFactoids, State } from './help';
import pb from './pubsub';
const pubsub = pb.setup('search')
let userStore = new UserStorage({
    'markers': []
});

/*::
import addSectionToSearchTooltip from 'pageFragments'
import ui from 'javascriptLibs'
 */

interface SearchParams {
    type: 'main' | 'metrics' | 'preview'; // TODO: flatten this whole thing into searchId once preview is refactored
    searchFn: Function;
    serverSearch: boolean; // whether this search needs to fetch data from server (i.e. uses loading animation)
}

function findState(nameOrCode: string) {
    let stateCode = nameOrCode.trim().toUpperCase();
    let stateName = capitalize(nameOrCode);
    if (stateFactoids[stateCode]) {
        return {
            state: stateFactoids[stateCode].title,
            code: stateCode
        };
    } else {
        let code = Object.keys(stateFactoids).find(key => stateFactoids[key].title === stateName);
        if (code) {
            return {
                state: stateName,
                code: code
            };
        }
    }
}

// helps user by showing search tooltip
let cityList: City[] = [];
pubsub.subscribe('load:cities', (cities: City[]) => cityList = cities);

const mainSearch = ((document.getElementById('search-tooltip'): any): HTMLElement);
const previewSearch = ((document.getElementById('preview-search-tooltip'): any): HTMLElement);
let recentSearches = [];
fetch('/search/history').then(r => r.json()).then((search: { recent: RecentSearch[] }) => {
    recentSearches = search.recent.sort((a, b) => b.latest - a.latest);
});
function isCloseTo(query: string, item: string) {
    return item.toLowerCase().includes(query.toLowerCase())
}

let state = null;
const searchField = ((document.getElementById('search-field'): any): HTMLInputElement);
const previewSearchField = ((document.getElementById('preview-search-field'): any): HTMLInputElement);
// const searchBtn = ((document.getElementById('search-btn'): any): HTMLElement);
// searchBtn.addEventListener('click', () => {
//     search(searchField.value);
// });

// template used by this page's search field
let normalized = true;
let selectedSuggestionIndex = -1;
let normalizedQuery = '';

let mainSearchField = {
    type: 'mainSearch',
    serverSearch: true,
    searchFn: search
}

// main search function, triggered by search submission
function search(query: string, searchParams: SearchParams = mainSearchField): Promise {
    pubsub.publish('notify:startLoad', "Searching...");

    if (/^\d{5}$/.test(query)) {
        // zipcode search
        return normalize('zip', query, searchParams);
    } else if (/^zip:/.test(query)) {
        // normalized zipcode
        let index = query.indexOf(':');
        let subQuery = query.slice(index + 1).trim();
        return normalize('zip', subQuery, searchParams);
    } else if (/^marker:/.test(query)) {
        // marker search, return first marker that satisfies regex
        let index = query.indexOf(':');
        let subQuery = query.slice(index + 1).trim();
        return userStore.get('markers').then(markers => {
            for (var i = 0; i < markers.length; i++) {
                let marker = markers[i];
                if (new RegExp(subQuery).test(marker.name)) {
                    normalize('marker', marker, searchParams);
                    return;
                }
            }
            throw new Error('Location not found')
        });
    } else if (state = findState(query)) {
        // state search via 2-letter code or name
        return normalize('state', {
            query: state.state,
            key: state.code
        }, searchParams);
    } else {
        // geocode search
        return normalize('geocode', query, searchParams);
    }
}

// normalizes search value for future use
// if search is true (meaning the call was done via searchbox), follows up by searching the location on the map, if false assumes the map already found the location
function normalize(type: string, result: Marker | City | string | { query: string, key: string }, searchParams: SearchParams = mainSearchField, search = true): Promise {
    let query = '';
    let key;
    if (type === 'marker') {
        // @flow-ignore
        key = result.id;
        // @flow-ignore
        query = `marker: ${result.name}`;
    } else if (type === 'city') {
        // @flow-ignore
        key = typeof result === 'string' ? result : `${result.city}, ${result.state}`;
        query = key;
    } else {
        if (typeof result === 'string' || typeof result === 'number') {
            key = result;
            query = result;
        } else {
            // @flow-ignore: we know this can only be 1 type now
            query = result.query;
            // @flow-ignore: we know this can only be 1 type now
            key = result.key;
        }
    }
    return fetch('/search/history', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            type,
            query,
            key
        })
    }).then(r => r.json()).then(data => {
        if (data.error) {
            throw new Error('Location not found')
        }

        // This fires the following events:
        //  search:geocode
        //  search:zipcode
        //  search:state
        //  search:marker
        //  search:city
        //  preview:geocode
        //  preview:zipcode
        //  preview:state
        //  preview:marker
        //  preview:city
        if (type === 'geocode') {
            if (data.quality === 'none') {
                throw new Error('Location not found')
            } else {
                // setMdlVal(searchParams.field, data.normalized);
                search && pubsub.publish(`${searchParams.type}:geocode`, data); // notify system of search result (to load on map)
            }
        } else {
            if (type === 'zip') {
                search && pubsub.publish(`${searchParams.type}:zipcode`, key);
            } else if (type === 'state') {
                search && pubsub.publish(`${searchParams.type}:state`, result);
            } else if (type === 'marker') {
                search && pubsub.publish(`${searchParams.type}:marker`, result);
            } else if (type === 'city') {
                search && pubsub.publish(`${searchParams.type}:city`, result);
            }
            // @flow-ignore: flow doesn't understand that we already tested for marker via type beforehand
            // setMdlVal(searchParams.field, query);
        }
        // searchParams.field.classList.add('found');
        // searchParams.field.blur();
        normalized = true;
        normalizedQuery = data.normalized || query;
    })
}

// template used by search fields
const template = {
    recent: {
        title: 'Recently Viewed',
        prefix: 'history',
        element: (s: RecentSearch) => {
            let icon = 'apartment';
            let qty = 1;
            if (s.type === 'geocode') {
                icon = 'gps_fixed'
            } else if (s.type === 'marker') {
                icon = 'room'
            } else if (s.type === 'city') {
                icon = 'location_city';
            }
            let icons = `<i class="mdl-icon-toggle__label material-icons">${icon}</i>`.repeat(qty)
            // return `${icons}<span class="query">${s.query}</span>`
            return {
                icon,
                type: s.type,
                query: s.query
            }
        },
        fetchFn: (query: string) => {
            let result = recentSearches.filter(s => isCloseTo(query, s.query))
            return Promise.resolve(result)
        },
        onClick: (s: RecentSearch, searchParams: SearchParams) => {
            let normalized = {
                query: s.query,
                key: s.key
            }
            if (s.type === 'marker') {
                userStore.get('markers').then(markers => {
                    const marker = markers.find(m => m.id === s.key);
                    normalize('marker', marker);
                });
                return;
            } else if (s.type === 'city') {
                normalized = cityList.find(c => `${c.city}, ${c.state}` === s.key);
            } else if (s.type === 'zip') {
                normalized.key = normalized.query; // fixes issue with sqlite thinking zipcode is a number
            }
            // @flow-ignore: flow doesn't udnerstand category is optional
            normalize(s.type, normalized, searchParams);
            return s.query
        }
    },
    markers: {
        title: 'Markers',
        prefix: 'marker',
        element: (m: Marker) => {
            // `<i class="mdl-icon-toggle__label material-icons">${m.icon}</i><span class="query">${m.name} (${m.zip})</span>`
            return {
                icon: m.icon,
                type: 'Marker',
                query: `${m.name} (${m.zip})`
            }
        },
        fetchFn: (query: string) => {
            return userStore.get('markers').then(markers => {
                return markers.filter(m => isCloseTo(query, m.name));
            });
        },
        onClick: (m: Marker, searchParams: SearchParams) => {
            normalize('marker', m, searchParams);
            return m.name
        }
    },
    cities: {
        title: 'Cities',
        prefix: 'city',
        element: (c: City) => {
            // `
            // <span class="query">${c.city}, ${c.state}</span>
            // <span class="pop">
            //     <i class="material-icons">person</i>
            //     ${c.pop.toLocaleString()}
            // </span>`
            return {
                icon: 'location_city',
                type: 'City',
                query: `${c.city}, ${c.state}`,
                pop: (c.pop || 0).toLocaleString()
            }
        },
        fetchFn: (query: string) => Promise.resolve(cityList.filter(c => isCloseTo(query, c.city))),
        onClick: (c: City, searchParams: SearchParams) => {
            normalize('city', c, searchParams);
            return `${c.city}, ${c.state}`
        }
    },
    states: {
        title: 'States',
        prefix: 'state',
        element: (s: State) => {
            // `
            // <span class="query">${s.title}</span>
            // <span class="pop">
            //     <i class="material-icons">person</i>
            //     ${s.Population}
            // </span>`
            return {
                query: s.title,
                type: 'State',
                pop: s.Population
            }
        },
        fetchFn: (query: string) => {
            return Promise.resolve(Object.entries(stateFactoids).map((e: [string, Object]) => {
                return {
                    ...e[1],
                    code: e[0]
                }
            }).filter((s: State) => isCloseTo(query, s.title)))
        },
        onClick: (s: State, searchParams: SearchParams) => {
            normalize('state', {
                query: s.title,
                key: s.code
            }, searchParams);
            return s.title
        }
    },
    zipcodes: {
        title: 'Zip Codes',
        prefix: 'zip',
        element: (z: ZipCode) => {
            // `
            // <span class="query">${z.city}, ${z.state} (${z.zipcode.toString().padStart(5, '0')})</span>
            // <span class="pop">
            //     <i class="material-icons">person</i>
            //     ${(z.population || 0).toLocaleString()}
            // </span>`
            return {
                query: `${z.city}, ${z.state} (${z.zipcode.toString().padStart(5, '0')})`,
                type: 'Zip Code',
                pop: (z.population || 0).toLocaleString()
            }
        },
        fetchFn: (query: string) => {
            if (/^(\d{1,5}|[A-Za-z- ]+)$/.test(query)) { // only make request for fully numeric or fully alpha
                return fetch(`/search/zip?query=${query}`).then(r => r.json()).then(data => {
                    return data.results;
                })
            }
            return Promise.resolve([])
        },
        onClick: (z: ZipCode, searchParams: SearchParams) => {
            let zip = z.zipcode.toString().padStart(5, '0')
            normalize('zip', zip, searchParams);
            return zip
        }
    }
};

// ([
//     mainSearchField,
//     { field: previewSearchField, context: previewSearch, searchFn: search, type: 'preview'},
// ]).forEach(f => buildSearch(f, template))

// only applicable to main search
let clearBtn = ((document.getElementById('clear-search'): any): HTMLElement);
pubsub.subscribe('location:load', (result: {
    type: string,
    query: ?string,
    obj: ?Marker
}) => {
    let object = result.obj || result.query;
    if (result.type === 'state') {
        // @flow-ignore: state guarantees query
        let state = ((findState(result.query): any): State);
        object = {
            query: state.state,
            key: state.code
        }
    }
    normalize(result.type, object, mainSearchField, false);
    //clearBtn.style.display = "";
});
// pubsub.subscribe('zoom:reset', () => {
//     // clear location
//     searchField.value = '';
//     searchBtn.innerText = 'search';
//     clearBtn.style.display = "";
// });
/*let clearEvent = ((clearBtn.onclick: any): Function);
clearBtn.onclick = (e) => {
    if (normalized) {
        // reset zoom
        ui.zoomOutState();
        clearEvent(e);
        normalizedQuery = '';
    } else {
        // simply clear field (like Esc)
        clearEvent(e);
    }
}*/

function buildSearch(searchParams: SearchParams, template) {

    const context = {}
    Object.keys(template).forEach(k => context[k] = [])

    // generate sections (result categories)
    const searchSections = {}
    // Object.entries(template).forEach(([k, v]) => {
    //     searchSections[k] = addSectionToSearchTooltip(v.title, searchParams.context)
    // })

    function fetchSearchContext(query: string) {
        const firstQueryWord = query.split(/[\s:,]/)[0];
        // check for usage of magic prefix that limits to specific section
        const hardcoded = Object.values(template).map(v => v.prefix).find((e) => e === firstQueryWord);
        const sectionQuery = hardcoded ? query.slice(hardcoded.length).replace(/^[:]?\s*/, '') : query;
        // @flow-ignore: flow is being stupid, we're not changing types here
        Object.keys(context).forEach(k => context[k] = []);
        if (query.length > 2) {
            Object.keys(template).forEach(k => {
                let section = template[k]
                if (!hardcoded || hardcoded === section.prefix) {
                    section.fetchFn(query).then(results => {
                        context[k] = results
                        // updateSearchContext()
                    })
                }
            })
        } else {
            // searchParams.context.style.display = '';
        }
        console.log('search context' , context)
        return context
    }

    let searchFn = memoize(fetchSearchContext)
    pubsub.publish(`${searchParams.type}:acceptInput`, searchParams.searchFn)
    Object.entries(template).forEach(([categoryName, categoryTemplate]) => {
        //searchSections[k] = addSectionToSearchTooltip(v.title, searchParams.context)
        pubsub.publish(`${searchParams.type}:addCategory`, {
            name: categoryTemplate.title,
            searchFn: (name) => categoryTemplate.fetchFn(name).then(rows => rows.map(r => {
                return {
                    element: categoryTemplate.element(r),
                    clickFn: () => {
                        searchParams.serverSearch && pubsub.publish('notify:startLoad', 'Searching...');
                        categoryTemplate.onClick(r, searchParams)
                    },
                    hoverFn: (e: Event) => {
                        categoryTemplate.onHover && categoryTemplate.onHover(r, e)
                    }
                }
            })),
            selectFn: (id) => userStore.find('markers', { id }).then(m => window.zoomToMarker(m)),
        })
    })

    // react to updates to search box (once a promise resolves)
    const maxEntries = 20;
    let currentEntries = 0;
    function updateSearchContextSelection() {
        const selected = document.querySelector('.search-suggestion.selected')
        if (selected) {
            selected.classList.remove('selected');
        }
        const entries = document.querySelectorAll('.search-suggestion');
        entries[selectedSuggestionIndex].classList.add('selected');
    }
    function updateSearchContext() {
        console.log(context)
        //searchParams.context.style.display = 'block';
        let level = 0;
        currentEntries = 0;
        let entries: { [string]: HTMLElement[] } = {};
        while (level < maxEntries && currentEntries < maxEntries) {
            Object.keys(((context: any): { [string]: Object[] })).forEach(key => {
                if (!entries[key]) entries[key] = [];

                if (context[key].length > entries[key].length) {
                    let data = context[key][level]
                    const html = template[key].element;
                    // onclick needs to retain a bound closure, so we can't generate the element via html string
                    const element = document.createElement('DIV');
                    element.classList.add('search-suggestion');
                    element.onClick = () => {
                        template[key].onClick(data, searchParams);
                        //searchParams.context.style.display = '';
                    };
                    element.innerHTML = html(data);
                    entries[key].push(element);
                    currentEntries++;
                    // entries[key].push(`<div class="search-suggestion" onclick=>${entry.element}</div>`);
                }
            })
            level++;
        }
        // @flow-ignore: type is correct, flow is blind to earlier entries declaration
        // for (let [section, sectionEntries]: [string, HTMLElement[]] of Object.entries(entries)) {
        //     if (sectionEntries.length) {
        //         searchSections[section].section.style.display = 'block';
        //         searchSections[section].entries.innerHTML = ''; // clear previous entries
        //         for (const entry of entries[section]) {
        //             searchSections[section].entries.appendChild(entry);
        //         }
        //     } else {
        //         searchSections[section].section.style.display = 'none';
        //         searchSections[section].entries.innerHTML = '';
        //     }
        // }
    }

    // search functionality
    /*searchParams.field.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.keyCode === Key.ENTER) {
            event.preventDefault();
            if (selectedSuggestionIndex !== -1) {
                ((document.querySelector('.search-suggestion.selected .query'): any): HTMLElement).click();
            } else {
                searchParams.searchFn(searchParams.field.value, searchParams).catch(e => {
                    // inform the user of search failure
                    searchParams.field.classList.add('not-found');
                    pubsub.publish('notify:error', e.message);
                    pubsub.publish('notify:load:stop');
                })
            }
        } else if (event.keyCode === Key.ESC) {
            searchParams.field.value = normalizedQuery;
            searchParams.context.style.display = '';
            if (normalizedQuery.length) {
                searchParams.field.classList.add('found');
                normalized = true;
            } else {
                clearBtn.style.display = "";
            }
        } else if (event.keyCode === Key.DOWN) {
            selectedSuggestionIndex++;
            if (selectedSuggestionIndex >= currentEntries) {
                selectedSuggestionIndex = 0;
            }
            updateSearchContextSelection();
            searchParams.field.value = ((document.querySelector('.search-suggestion.selected .query'): any): HTMLElement).innerText || '';
        } else if (event.keyCode === Key.UP) {
            selectedSuggestionIndex--;
            if (selectedSuggestionIndex < 0) {
                selectedSuggestionIndex = currentEntries - 1;
            }
            updateSearchContextSelection();
            searchParams.field.value = ((document.querySelector('.search-suggestion.selected .query'): any): HTMLElement).innerText || '';
        } else if (normalized) {
            // user starts typing again
            selectedSuggestionIndex = -1;
            searchParams.field.classList.remove('found');
            searchParams.field.classList.remove('not-found');
            normalized = false;
        }
    });
    // capture any organic update to field (including copy/paste)
    const tooltip = ((document.getElementById("tooltip"): any): HTMLElement);
    searchParams.field.addEventListener('input', () => {
        tooltip.style.display = 'none'; // hide the other tooltip so it doesn't get in the way if the user didn't move the mouse
        fetchSearchContext(searchParams.field.value);
    })
    // override original setValue (defined in header.html) to capture JS-based value update
    // @flow-ignore: we're not supposed to be setting properties on element directly, but we can
    searchParams.field.setValue = (v) => {
        fetchSearchContext(v);
        searchParams.field.value = v;
    }*/

}

pubsub.subscribe('setup:searchbox', ({searchParams, template}) => {
    buildSearch(searchParams, template)
})
setTimeout(() => {
    buildSearch(mainSearchField, template)
}, 2000)